import React from "react";

// Brand assets: deep terracotta, corrected artwork
const FOLK = "/refs/folk-wordmark-new.png";
const OBJECTS = "/refs/objects-wordmark-new.png";
const STACKED_MOBILE = "/refs/folk-mobile-stacked.png";

/**
 * variant="stacked": vertical mobile asset (FOLK over OBJECTS).
 * variant="inline":  side-by-side, compact.
 * variant="split":   FOLK left, OBJECTS right on all breakpoints.
 *                    On mobile the two sides shrink and the gap tightens
 *                    responsively, but the split treatment is preserved.
 */
export default function Logo({ variant = "stacked", size = 44, testId = "folk-logo", style }) {
  if (variant === "split") {
    return (
      <div
        data-testid={testId}
        aria-label="Folk Objects"
        className="folk-logo-split"
        style={{ "--folk-logo-h": `${size}px`, ...style }}
      >
        <div className="folk-logo-split__desktop">
          <img className="folk-logo-split__folk" src={FOLK} alt="Folk" />
          <img className="folk-logo-split__objects" src={OBJECTS} alt="Objects" />
        </div>
      </div>
    );
  }

  if (variant === "inline") {
    return (
      <div
        data-testid={testId}
        aria-label="Folk Objects"
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: size * 0.4,
          ...style,
        }}
      >
        <img src={FOLK} alt="Folk" style={{ height: size, width: "auto", display: "block" }} />
        <img src={OBJECTS} alt="Objects" style={{ height: size, width: "auto", display: "block" }} />
      </div>
    );
  }

  // stacked: vertical mobile asset (FOLK / OBJECTS on top of each other)
  return (
    <div data-testid={testId} aria-label="Folk Objects" style={{ display: "inline-flex", justifyContent: "center", ...style }}>
      <img src={STACKED_MOBILE} alt="Folk Objects" style={{ height: size * 2.4, width: "auto", display: "block" }} />
    </div>
  );
}
